import React from "react";
import ReactDOM from "react-dom";

import App from "./components/App/App";

import "./globalStyles";
//import registerServiceWorker from "./registerServiceWorker";
import { createBrowserHistory } from "history";
import "./polyfills";
import "./icons";

ReactDOM.render(
  <App history={createBrowserHistory()} />,
  document.getElementById("root")
);
//registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js